/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { UsersListComp, Header } from '../components';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { useTheme } from '../../../providers/theme';
import { useSMRejectedApplicationsPageGetContent } from '../machines';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { vappContainer, VApplication } from '../../../application';
import { SettingsComp } from '../components/Settings';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';
import { RejectedAppPageService } from '../services';
import { Loader } from '@/components';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';

const getSrv = () => {
  return vappContainer.get<RejectedAppPageService>(
    RejectedAppPageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshPagination, setReFreshPagination] = useState(new Date());
  const staticPageContentConfig = getSrv()?.agent?.getStaticPageContentSync({});
  const srv = getSrv();

  const {
    getRejectedApplicationsPageSend,
    getRejectedApplicationsPageState,
    getRejectedApplicationsPageMachine,
  } = useSMRejectedApplicationsPageGetContent({});

  // const { getRe}

  const _onHeaderDDActionItemClick = (id: string) => {};
  const onAddUser = (id: string) => {
    if (!showModal) {
      setShowModal(true);
    }
  };
  const onError = () => {
    //window.location.reload(false);
    getRejectedApplicationsPageSend('TRIGGER_REFRESH', {});
  };

  const onModalClose = () => {
    if (showModal) {
      setShowModal(false);
    }
  };
  const onAddNewUser = (data: any) => {
    console.log(`profile data`, data);
    if (showModal) {
      setShowModal(false);
    }
    // inviteUserSend("START", {
    //   payload: data,
    // });
  };

  const onHeaderAction2Click = (id: string) => {
    if (id) {
      switch (id) {
        case 'import_users':
          toast.success('Coming soon!');
          // history.push(
          //   `${routesConfig?.routes?.UsersBatch?.path}`
          // );
          break;
        default:
          console.log(`unsupported header button id ${id} clicked`);
      }
    }
  };

  // const onAddNewUser = (
  //   email: string,
  //   firstName: string,
  //   lastName: string,
  //   invite: boolean
  // ) => {
  //   console.log(`on add new user `, email, firstName, lastName, invite);
  //   inviteUserSend("START", {
  //     payload: {
  //       email: email,
  //       firstName: firstName,
  //       lastName: lastName,
  //       invite: invite,
  //     },
  //   });
  // };

  const _addNewUser = () => {
    if (showModal) {
      return (
        // <NewUserModal
        //   showModal={showModal}
        //   onAcknowledgement={onAddNewUser}
        //   onDeny={onModalClose}
        // />
        <TweetyModal
          show={true}
          size={'lg'}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Invite'}
          onSubmit={onAddNewUser}
          onHide={() => setShowModal(false)}
          title={'Invite Admin'}
          tweetyWidgetProps={{
            fields: staticPageContentConfig?.newUser?.FIELDS,
            layout: staticPageContentConfig?.newUser?.layout,
          }}
        />
      );
    }
  };

  const onRefresh = () => {
    getRejectedApplicationsPageSend('TRIGGER_REFRESH', {});
    setReFreshPagination(new Date());
  };

  const onClearFilter = () => {
    Array.from(document.querySelectorAll('input')).forEach(
      (input) => (input.value = '')
    );
    getRejectedApplicationsPageSend('TRIGGER_REFRESH', {});
  };
  const onApplyFilter = (data: any, status: any) => {
    let criteria: any = [];
    console.log('useSMRejectedApplicationsPageGetContent->where->data', data);
    if (data?.applicationId) {
      criteria = [
        {
          column: 'applicationNo',
          op: 'Equal',
          value: data?.applicationId,
        },
      ];
    }

    getRejectedApplicationsPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
    console.log('useSMRejectedApplicationsPageGetContent->where', criteria);
  };
  const onAppl6yFilter = (data: any) => {
    let criteria: any = [];
    criteria =
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        return {
          column: item?.filters?.inputData?.id,
          op: item?.filters?.inputData?.label,
          value: [item?.filters[item?.filters?.inputData?.label]],
        };
      });
    getRejectedApplicationsPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  // const _renderPage = () => {
  //   if (
  //     getRejectedApplicationsPageState?.matches('RENDER_PAGE') &&
  //     getRejectedApplicationsPageState?.event?.data?.value
  //   ) {
  //     console.log(
  //       `getRejectedApplicationsPageState :`,
  //       getRejectedApplicationsPageState?.event?.data?.value,
  //       staticPageContentConfig
  //     );
  //     return (
  //       <>
  //         {getRejectedApplicationsPageState?.event?.data?.value?.isEmpty ? (
  //           <Loader
  //             {...(staticPageContentConfig?.loading?.usersEmpty || {})}
  //           />
  //         ) : (
  //           <UsersListComp
  //             {...getRejectedApplicationsPageState?.event?.data?.value}
  //             // {...(getRejectedApplicationsPageState?.event?.data?.value || {})}
  //             onViewClick={props.onViewClick}
  //             onRowClick={props?.onViewDetailClick}
  //           />
  //         )}
  //       </>
  //     );
  //   }
  //   if (getRejectedApplicationsPageState?.matches('GET_PAGE_CONTENT')) {
  //     return (
  //       <Loader {...(staticPageContentConfig?.loading?.loadingUsers || {})} />
  //     );
  //   }
  //   return <></>;
  // };

  const _renderPage = () => {
    //console.log("renderpage",usersListPageState?.event?.data?.value);

    if (getRejectedApplicationsPageState?.matches('RENDER_PAGE')) {
      console.log(
        'stateval->',
        getRejectedApplicationsPageState?.event?.data?.value
      );
      return (
        <>
          {getRejectedApplicationsPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(staticPageContentConfig?.loading?.usersEmpty || {})}
            />
          ) : (
            <UsersListComp
              {...(getRejectedApplicationsPageState?.event?.data?.value || {})}
              onViewClick={props?.onViewClick}
              onRowClick={props?.onViewDetailClick}
            />
          )}
        </>
      );
    }
    if (getRejectedApplicationsPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.loadingUsers || {})} />
      );
    }
    return (
      <>
        {getRejectedApplicationsPageState?.event?.data?.value?.isEmpty ? (
          <StateOSD {...(staticPageContentConfig?.loading?.usersEmpty || {})} />
        ) : (
          <UsersListComp
            // {...(usersListPageState?.event?.data?.value || {})}
            {...staticPageContentConfig?.sampleData}
            onViewClick={props?.onViewClick}
            onRowClick={props?.onViewDetailClick}
          />
        )}
      </>
    );
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onHeaderAction1Click={onAddUser}
            onHeaderDDActionItemClick={_onHeaderDDActionItemClick}
            onHeaderAction2Click={onHeaderAction2Click}
            onRefreshClick={onRefresh}
          />
          {/* <SearchFilter
            {...(staticPageContentConfig?.settings || {})}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          /> */}
          <SettingsComp
            {...(staticPageContentConfig?.settings || {})}
            onApplyFilter={onApplyFilter}
            onClearFilter={onClearFilter}
          />
        </>
      );
    }
    return null;
  };

  const onPaginationChange = (event: any) => {
    getRejectedApplicationsPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    if (!getRejectedApplicationsPageState?.event?.data?.value?.isEmpty) {
      return (
        <Paginate
          {...(getRejectedApplicationsPageState?.event?.data?.value || {})}
          onPageChange={onPaginationChange}
          key={refreshPagination}
          totalItems={
            getRejectedApplicationsPageState?.event?.data?.value?.ultUsers
              ?.length
          }
        />
      );
    }
  };

  const _renderErrorModals = () => {
    if (getRejectedApplicationsPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getUsers || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };

  return (
    <div>
      {_renderHeader()}
      {_renderPage()}
      {_renderPagination()}
      {_renderErrorModals()}
      {_addNewUser()}
    </div>
  );
};
